import { useMemo } from 'react';

export function useAccessToken(): string | null {
    return useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get('token') || params.get('accessToken');
    }, []);
}
